module.exports = __webpack_public_path__ + "assets/img/ai_bgc.24e3c049.png";